// src/poker/components/ClockPanel.js
import React from "react";
import { fmtTime, money } from "../pokerClock.logic";

export default function ClockPanel({
  settings,
  current,
  remainingSec,
  running,
  prizePool,
  onPrev,
  onNext,
  onToggleRunning,
  onResetLevel,
}) {
  return (
    <div className="panel-card">
      <div style={{ display: "flex", alignItems: "baseline", gap: 12, flexWrap: "wrap" }}>
        <div style={{ fontSize: 13, opacity: 0.85 }}>
          {settings.title || "Turniej"} · gracze: <b>{settings.players}</b> · start stack:{" "}
          <b>{money(settings.startingStack)}</b>
        </div>
        <div style={{ marginLeft: "auto", fontSize: 13, opacity: 0.85 }}>
          pula nagród: <b>{money(prizePool)}</b>
        </div>
      </div>

      <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <div style={{ fontSize: 13, opacity: 0.85 }}>
          Poziom: <b>{current?.label || "-"}</b>
        </div>

        <div style={{ fontSize: 13, opacity: 0.85 }}>
          Blindy:{" "}
          <b>{current ? `${money(current.sb)} / ${money(current.bb)}` : "-"}</b>
          {current?.ante ? (
            <>
              {" "}
              · ante: <b>{money(current.ante)}</b>
            </>
          ) : null}
        </div>

        <div style={{ marginLeft: "auto", fontSize: 13, opacity: 0.85 }}>
          (spacja: start/pauza, ←/→: poziom)
        </div>
      </div>

      <div
        style={{
          marginTop: 14,
          fontSize: "clamp(3.2rem, 7vw, 5rem)",
          fontWeight: 800,
          letterSpacing: 1,
          textAlign: "center",
          lineHeight: 1.05,
          textShadow: "0 0 18px rgba(255,165,0,0.15)",
        }}
      >
        {fmtTime(remainingSec)}
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap", marginTop: 10 }}>
        <button className="btn-secondary" type="button" onClick={onPrev}>
          ← Poprzedni
        </button>

        <button
          className="btn-primary"
          type="button"
          onClick={onToggleRunning}
          style={{ borderColor: running ? "rgba(255,165,0,0.9)" : undefined }}
        >
          {running ? "Pauza" : "Rozpocznij"}
        </button>

        <button className="btn-secondary" type="button" onClick={onResetLevel}>
          Reset poziomu
        </button>

        <button className="btn-secondary" type="button" onClick={onNext}>
          Następny →
        </button>
      </div>
    </div>
  );
}
